import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  text: {
    textDecoration: 'none',
    color: 'grey'
  },
  link: {
    textDecoration: 'none'
  },
  container: {
    height: 40,
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
